import { Category } from 'vms-base';
import PropTypes from 'prop-types';
import { isEmpty } from 'ramda';
import { Component } from 'react';
import * as constants from '../../backend/constants';
import SelectFieldEditor from '../select-field-editor/SelectFieldEditor.jsx';
import s from './BulkChangeConfigurator.module.scss';

export default class BulkCategoryEditor extends Component {
    static propTypes = {
        accountId: PropTypes.string,
        categories: PropTypes.arrayOf(PropTypes.object),
        changeType: PropTypes.string,
        getBadgeOptions: PropTypes.func,
        isV5: PropTypes.bool,
        onChange: PropTypes.func,
        onSubChange: PropTypes.func,
        subValue: PropTypes.string,
        value: PropTypes.string,
        venueId: PropTypes.string,
    };

    static defaultProps = {
        accountId: '',
        categories: [],
        changeType: '',
        getBadgeOptions: () => [],
        isV5: true,
        onChange: () => {},
        onSubChange: () => {},
        subValue: '',
        value: '',
        venueId: '',
    };

    renderEmpty = () => <SelectFieldEditor disabled />;

    renderEditor = () => {
        const { value, onChange, categories } = this.props;

        return <SelectFieldEditor options={Category.asDropdownOptions(categories)} selectedValue={value} onValueSelected={onChange} />;
    };

    renderSubEditor = () => {
        const { value, subValue, onSubChange, categories, isV5, getBadgeOptions, venueId, accountId } = this.props;

        if (value === '') return this.renderEmpty();

        const category = Category.fromCategoryList(value, categories);
        const iconOptions = !isEmpty(category) && isV5 !== undefined ? getBadgeOptions(category, isV5, venueId, accountId) : [];
        return <SelectFieldEditor categoryIcons options={iconOptions} selectedValue={subValue} onValueSelected={onSubChange} disabled={iconOptions.length === 0} />;
    };

    render() {
        const { changeType } = this.props;
        if (changeType !== constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.CATEGORY_CHANGE) {
            return null;
        }

        return (
            <div>
                <div className={s.dividerWithText}>With the following category</div>
                {this.renderEditor()}
                <div className={s.dividerWithText}>and the following icon</div>
                {this.renderSubEditor()}
            </div>
        );
    }
}
